import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/shared/services/data/data.service';

@Component({
  selector: 'app-prameters-home',
  templateUrl: './prameters-home.component.html',
  styleUrls: ['./prameters-home.component.scss']
})
export class PrametersHomeComponent implements OnInit {

  constructor(
    private dataService: DataService
  ) { }

  ngOnInit(): void {
  }

  gotoShowBtnParamFluxActu(): void {
    this.dataService.showBtnParamFluxActu.next(true);
  }
  gotoShowBtnParamMenu(): void {
    this.dataService.showBtnParamMenu.next(true);
  }

}
